import { render, staticRenderFns } from "./NP.vue?vue&type=template&id=b21ffc5a&"
import script from "./NP.vue?vue&type=script&lang=js&"
export * from "./NP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports